import { makeStyles } from '@mui/styles'

const appButtonStyles = makeStyles(theme => ({
  ButtonBox: {
    maxWidth: '220px',
    minHeight: '48px',
    background: "#F37320",
    borderRadius: '4px',
    margin: '10px auto',
    width: '100%',
    display: 'block',
    color: 'white !important',

    '&:hover': {
      background: '#F37320'
    }
  },
  PlainButtonBox: {
    border: '#F37320 1px solid',
    background: "#FFF",
    color: '#F37320 !important',

    '&:hover': {
      background: '#FFF'
    }
  },
  disable: {
    opacity: '50%',
    pointerEvents: 'none'
  },
}))

export { appButtonStyles }